import { setI18nLanguage, defaultLang } from '@/locales'
import i18n from '@/locales'

import { LanguageServiceProxy } from '@/service-proxies/app-v2/language.service-proxies'
import { findAllLangs } from '@/api/api'
import { getLocalLanguage } from '@/utils/index'
import { getUserInfo } from '@/utils/auth'
const languageServiceProxy = new LanguageServiceProxy()

const state = {
  langLibrary: [{
    [defaultLang]: {}
  }],
  lang: defaultLang,
  loadedLanguages: []
}

const mutations = {
  SET_LANG: (state: any, lang: any) => {
    state.lang = lang
  },
  SET_LANG_LIBRARY: (state: any, langLibrary: any) => {
    state.langLibrary = langLibrary
  },
  CLEAR_LOADED_LANGUAGES:(state: any) => {
    state.loadedLanguages = []
  },
  ADD_LOADED_LANGUAGES: (state: any, lang: any) => {
    state.loadedLanguages.push(lang)
  }
}

const actions = {
  setLang({ commit }: any, lang: any) {
    commit('SET_LANG', lang)
    setI18nLanguage(lang)
  },
  async changeLang({rootState, dispatch, commit, state}: any, lang: any) {
    if(state.lang == lang) return
    dispatch('setLang', lang)
    //从服务器获取语言值列表
    if(state.loadedLanguages.indexOf(lang) >= 0) return
    const user_info =  getUserInfo()
    const msgs: any = await findAllLangs(user_info.tenant_id, lang)
    i18n.setLocaleMessage(lang, getLocalLanguage(msgs.data.data))
    commit('ADD_LOADED_LANGUAGES', lang)
  },
  async initializeLang({ rootState, dispatch, commit, state }: any, ) {
    //退出当前app时需要把loadedLanguages置为空
    
    //从服务器获取语种列表
    const langs = await languageServiceProxy.findTenantLanguageList()
    let lang = getLocalLanguage('')
    const langsMap = langs.map(item => {
      return {
        displayName: item.displayName,
        name: item.name
      }
    })
    commit('SET_LANG_LIBRARY', langsMap)

    if(lang === null) {
      lang = defaultLang
      dispatch('setLang', lang)
    }else if(defaultLang !== lang) {
      dispatch('setLang', lang)
    }
    
    //从服务器获取语言值列表
    if(state.loadedLanguages.indexOf(lang) >= 0) return
    const user_info = getUserInfo() || {}
    const msgs: any = await findAllLangs(user_info.tenant_id, lang)
    i18n.setLocaleMessage(lang, getLocalLanguage(msgs.data.data))
    commit('ADD_LOADED_LANGUAGES', lang)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
